export default "__VITE_ASSET__DsAHhDrw__"